import React from 'react'
import { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import PreviewCompatibleImage from './PreviewCompatibleImage'
import { useAnimate, stagger, motion } from 'framer-motion'

// Individual project tile
const ProjectTile = (props) => {
	const { post, index } = props
	// const scope = useAnimation()

	const variants = {
		hidden: { 
			opacity: 0, 
			y: 50
		},
		visible: (i) => ({
			opacity: 1,
			y: 0,
			transition: {
				delay: i * 0.05, // Delay only applies here
			},
		}),
		hover: {
			scale: 1.02, // Example hover effect: scale up
			boxShadow: '5px 5px 20px 0px rgba(0,0,0,0.1)', // x y blur spread color
		},
	}

	// useEffect(() => {

	// }, []) // Empty dependency array means this effect runs only once after the component mounts

	return (
		<Link to={post.fields.slug}>
			<motion.div
				variants={variants}
				initial='hidden'
				animate='visible'
				// transition={{}}
				whileHover='hover'
				exit='unhover'
				custom={index}
				className={`project cell ${post.frontmatter.featured ? 'is-featured' : ''}`}
			>
				{/* Header */}
				<header>
					{post?.frontmatter?.image && (
						<div className='featured-thumbnail'>
							<PreviewCompatibleImage
								imageInfo={{
									image: post.frontmatter.image,
									alt: `featured image thumbnail for post ${post.frontmatter.title}`,
								}}
							/>
						</div>
					)}
				</header>

				{/* Body */}
				<div className='body'>
					<div className='post-meta'>
						<p className='title has-text-primary is-size-5 has-text-weight-semibold mb-2'>
							{post.frontmatter.title}
						</p>

						<p className='has-text-grey is-size-6 has-text-weight-normal'>{`${post.frontmatter.subtitle}`}</p>
						{/* <p className='excerpt is-block'>{post.excerpt}</p> */}
					</div>

					{/* <Link className='button' to={post.fields.slug}>
					Learn More
				</Link> */}
				</div>
			</motion.div>
		</Link>
	)
}

export default ProjectTile